export default function KerrvilleLogo() {
  return (
    <div className="flex items-center gap-3">
      {/* Logo Icon */}
      <div className="relative w-12 h-12 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0077B6] to-[#00D9FF] rounded-lg transform rotate-6"></div>
        <div className="relative z-10 w-11 h-11 bg-white rounded-lg flex items-center justify-center">
          <i className="ri-heart-pulse-line text-[#0077B6] text-2xl"></i>
        </div>
      </div>
      
      {/* Logo Text */}
      <div className="flex flex-col">
        <span className="text-xl font-bold text-gray-900 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          West Insurance
        </span>
        <span className="text-xs text-gray-600 font-medium tracking-wide">
          KERRVILLE HEALTH EXPERTS
        </span>
      </div>
    </div>
  );
}
